module.exports = __webpack_public_path__ + "static/media/ico-video-camera.079a028f.svg";